export type ContasPagarPeriodoVencimentoPreset =
  | "hoje"
  | "7d"
  | "30d"
  | "mes"
  | "personalizado";

export function formatarYmdLocalCp(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function inicioFimMesCorrenteLocalCp(): {
  vencimentoInicio: string;
  vencimentoFim: string;
} {
  const now = new Date();
  const ini = new Date(now.getFullYear(), now.getMonth(), 1);
  const fim = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  return {
    vencimentoInicio: formatarYmdLocalCp(ini),
    vencimentoFim: formatarYmdLocalCp(fim),
  };
}

export function periodoVencimentoParaDatasCp(
  preset: ContasPagarPeriodoVencimentoPreset,
): { vencimentoInicio: string; vencimentoFim: string } | null {
  const hoje = new Date();
  const ymd = formatarYmdLocalCp;

  switch (preset) {
    case "hoje": {
      const d = ymd(hoje);
      return { vencimentoInicio: d, vencimentoFim: d };
    }
    case "7d": {
      const fim = new Date(hoje);
      fim.setDate(fim.getDate() + 7);
      return { vencimentoInicio: ymd(hoje), vencimentoFim: ymd(fim) };
    }
    case "30d": {
      const fim = new Date(hoje);
      fim.setDate(fim.getDate() + 30);
      return { vencimentoInicio: ymd(hoje), vencimentoFim: ymd(fim) };
    }
    case "mes":
      return inicioFimMesCorrenteLocalCp();
    default:
      return null;
  }
}
